export class GuidUtils {
  private static _validator = new RegExp('^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$', 'i');
  private static _empty = '00000000-0000-0000-0000-000000000000';

  public static isGuid(value: string): boolean {
    return this._validator.test(value);
  }

  public static raw(): string {
    return [this.gen(2), this.gen(1), this.gen(1), this.gen(1), this.gen(3)].join('-');
  }

  public static isEmpty(value: string): boolean {
    return value === this._empty;
  }

  private static gen(count: number): string {
    let out = '';

    for (let i: number = 0; i < count; i++) {
      out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return out;
  }
}
